import _ from 'lodash';
import * as t from './actionTypes';

const initialState = {
  companies: {},
  partners: {},
  properties: {},
};

export const getInitialState = (customState = {}) => ({
  ...initialState,
  ...customState,
});

export const companies = (state = initialState.companies, action) => {
  switch (action.type) {
    case t.ADMIN_LOAD_COMPANIES_SUCCESS:
      return action.payload;
    case t.ADMIN_LOAD_COMPANY_SUCCESS:
    case t.ADMIN_CREATE_COMPANY_SUCCESS:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    case t.ADMIN_UPDATE_COMPANY_SETTINGS_SUCCESS:
      return {
        ...state,
        [action.meta.companyId]: {
          ...state[action.meta.companyId],
          settings: action.payload,
        },
      };
    default:
      return state;
  }
};

export const partners = (state = initialState.partners, action) => {
  switch (action.type) {
    case t.ADMIN_LOAD_PARTNERS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

export const properties = (state = initialState.properties, action) => {
  switch (action.type) {
    case t.ADMIN_LOAD_COMPANY_PROPERTIES_SUCCESS:
      return _.keyBy(action.payload, 'id');
    case t.ADMIN_UPDATE_COMPANY_PROPERTY_STATUS_SUCCESS: {
      const newState = _.clone(state);
      _.map(action.payload, updatedProperty => {
        newState[updatedProperty.id] = updatedProperty;
      });
      return _.keyBy(newState, 'id');
    }
    default:
      return state;
  }
};
